'use client';

import type { ReactNode } from 'react';
import { LoaderCircle, TriangleAlert } from 'lucide-react';
import dataEmpty from '@/assets/images/ic_list_empty.png';
import {cn} from "@/shared/lib/utils.ts";
import {EPrimaryBtn} from "@/shared/components";

export type EListStatusType = 'loading' | 'empty' | 'error';

export interface EListStatusProps {
    className?: string;
    emptyDescription?: string;
    emptyTitle?: string;
    listEmptyIcon?: ReactNode;
    errorDescription?: string;
    errorTitle?: string;
    onRetry?: () => void;
    loadingText?: string;
    status: EListStatusType;
}

export function EListStatus({
                                className,
                                emptyDescription = '',
                                emptyTitle = '没有找到匹配的内容',
                                listEmptyIcon,
                                errorDescription = '加载数据时发生异常，请稍后重试。',
                                errorTitle = '加载失败',
                                onRetry,
                                loadingText = '正在加载中...',
                                status,
                            }: EListStatusProps) {
    return (
        <div
            className={cn(
                'flex h-full min-h-[280px] flex-col items-center justify-center rounded-[24px] border border-dashed border-white/10 bg-white/[0.02] px-6 text-center',
                className,
            )}
        >
            {status === 'loading' ? (
                <>
                    <LoaderCircle className="h-8 w-8 animate-spin text-[#B0B0B0]" />
                    <div className="mt-3 text-[13px] text-[#B0B0B0]">{loadingText}</div>
                </>
            ) : null}

            {status === 'empty' ? (
                <>
                    {listEmptyIcon ?? <img alt="空状态插图" className="h-30 w-32 p-2" src={dataEmpty} />}
                    <div className="mt-3 text-[13px] font-medium text-[#E1E1E1]">{emptyTitle}</div>
                    {emptyDescription ? <div className="mt-2 max-w-[320px] text-[12px] leading-6 text-[#B0B0B0]">{emptyDescription}</div> : null}
                </>
            ) : null}

            {status === 'error' ? (
                <>
                    <div className="flex h-11 w-11 items-center justify-center rounded-full border border-rose-500/20 bg-rose-500/10 text-rose-200 shadow-[0_0_0_1px_rgba(244,63,94,0.08)]">
                        <TriangleAlert className="h-5 w-5" />
                    </div>
                    <div className="mt-4 text-[15px] font-medium text-white/88">{errorTitle}</div>
                    <div className="mt-2 max-w-[320px] text-[13px] leading-6 text-white/48">{errorDescription}</div>
                    <EPrimaryBtn
                        type="button"
                        className="mt-5 h-10 rounded-full px-5"
                        onClick={onRetry}
                        disabled={!onRetry}
                    >
                        点击重试
                    </EPrimaryBtn>
                </>
            ) : null}
        </div>
    );
}